import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__main container">
        <div className="footer__brand">
          <img
            src="/images/commercial_carpet_cleaning_oxon_logo.png"
            alt="Commercial Carpet Cleaning Oxon"
            className="footer__logo"
          />
          <p className="footer__tagline">
            Professional commercial carpet cleaning across Oxfordshire.
            Family-run, fully insured, eco-friendly.
          </p>
        </div>

        <div className="footer__nav">
          <h4 className="footer__heading">Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/hotels">Hotels</Link></li>
            <li><Link to="/offices">Offices</Link></li>
            <li><Link to="/domestic">Home Cleaning</Link></li>
            <li><Link to="/why-choose-us">Why Choose Us</Link></li>
          </ul>
        </div>

        <div className="footer__contact">
          <h4 className="footer__heading">Get In Touch</h4>
          <ul>
            <li>
              <a href="tel:+447887394404">07887 394404</a>
            </li>
            <li>
              <a href="mailto:commercialcarpetcleaningoxon@gmail.com">
                commercialcarpetcleaningoxon@gmail.com
              </a>
            </li>
            <li>Oxfordshire, United Kingdom</li>
          </ul>
          <Link to="/contact" className="btn btn--outline footer__cta">
            Request a Quote
          </Link>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <p>&copy; {currentYear} Commercial Carpet Cleaning Oxon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
